import { aggregateSearchQueryAndFilters, Firmware, searchFirmware } from '@infuse/api/cpms/firmware-management';
import { FilterCollection } from '@infuse/cpms/charging-station/filters';
import { useInfiniteQuery } from '@tanstack/vue-query';
import { last } from 'lodash';
import { computed, reactive, ref } from 'vue';
import { Pageable, Sort } from '@infuse/api/common';

export const useSearchFirmware = () => {
  const searchQuery = ref<string | undefined>();
  const filterCollection = reactive(new FilterCollection());
  const sort = reactive<Sort[]>([{ key: 'createdAt', descending: true }]);
  const rootId = ref<string | undefined>();
  const domainOnly = ref<boolean | undefined>();

  const query = useInfiniteQuery<Pageable<Firmware>>({
    initialPageParam: 0,
    queryKey: ['search-firmware', searchQuery, filterCollection, sort, rootId, domainOnly],
    queryFn: async ({ pageParam = 0 }) => {
      const filter = aggregateSearchQueryAndFilters({
        query: searchQuery.value,
        filter: filterCollection.toFilterExpression()
      });

      return await searchFirmware({
        size: 20,
        page: Number.parseInt(`${pageParam}`),
        filter,
        sort,
        rootId: rootId.value,
        domainOnly: domainOnly.value
      });
    },
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.pageable.pageNumber + 1)
  });

  const firmware = computed(() => query.data.value?.pages.flatMap((page) => page.content) || []);
  const currentPage = computed(() => (query.data.value ? (last(query.data.value.pageParams) as number) : 0));

  return {
    ...query,
    firmware,
    currentPage,
    searchQuery,
    filterCollection,
    sort,
    rootId,
    domainOnly
  };
};
